import React from 'react';
import styles from './AboutPage.module.css';
import {FeatureItem} from "../components/FeatureItem/FeatureItem";
import {RoadmapItem} from "../components/RoadmapItem/RoadmapItem";
import {StatWidget} from "../components/StatWidget/StatWidget";


const AboutPage = () => {
    return (
        <div className={styles.aboutPage}>
            <div className={styles.aboutContainer}>
                <h1 className={styles.pageTitle}>О проекте</h1>
                <div className={styles.subtitle}>Место, где код встречает креативность (и иногда кофе) ☕</div>

                <div className={styles.content}>
                    <div className={styles.mainContent}>
                        <section className={styles.section}>
                            <h2 className={styles.sectionTitle}>Что это за место? 🤔</h2>
                            <p className={styles.sectionText}>
                                Добро пожаловать в цифровое пространство, где идеи становятся кодом, а код - искусством!
                                Этот блог — не просто коллекция статей, а живой организм, который развивается вместе со
                                мной.
                                Здесь я делюсь своими впечатлениями, успехами, открытиями и навыками, которые приобретаю
                                на своем пути.
                            </p>
                            <p className={styles.sectionText}>
                                Главная особенность? Этот проект сам является площадкой для экспериментов!
                                Я не просто пишу о технологиях, но и внедряю их здесь и сейчас, превращая теорию в
                                практику.
                                Иногда с первой попытки, иногда после десятка чашек кофе ☕
                            </p>
                        </section>

                        <section className={styles.section}>
                            <h2 className={styles.sectionTitle}>Наша философия развития 🧠</h2>
                            <p className={styles.sectionText}>
                                Верю, что лучший способ чему-то научиться — это делать (и иногда ломать).
                                Каждая новая функция на сайте, каждый технический эксперимент — это шаг в
                                профессиональном росте.
                                Открыто делюсь не только успехами, но и процессом, включая ошибки и "озарения" в 3 часа
                                ночи.
                            </p>
                            <div className={styles.featureList}>
                                <FeatureItem title="Обучение через практику" emoji="🎯">
                                    Каждая технология сначала тестируется здесь (иногда с забавными результатами)
                                </FeatureItem>
                                <FeatureItem title="Открытость и прозрачность" emoji="🔍">
                                    Делюсь не только успехами, но и тем, как я искал ответ на Stack Overflow 3 часа
                                </FeatureItem>
                                <FeatureItem title="Сообщество вместо аудитории" emoji="👥">
                                    Уверен, что из одного участника вырастет сообщество (или хотя бы группа поддержки)
                                </FeatureItem>
                            </div>
                        </section>

                        <section className={styles.section}>
                            <h2 className={styles.sectionTitle}>Настоящее и будущее 🗺️</h2>
                            <p className={styles.sectionText}>
                                Сейчас проект находится в начале своего пути. Многие функции еще в разработке,
                                но это не недостаток — это возможность для роста (и оправданий, когда что-то не
                                работает).
                                Вот что уже работает и что появится скоро:
                            </p>

                            <div className={styles.roadmap}>
                                <RoadmapItem status="current" title="Сейчас доступно">
                                    <ul>
                                        <li>Публикация статей (если вы преодолели наш супер-сложный процесс регистрации)
                                            🎉
                                        </li>
                                        <li>Стильный дизайн (спасибо нашему "гениальному" дизайнеру - то есть мне) 🎨
                                        </li>
                                        <li>Базовая система авторов (пока только я, но я очень стараюсь) 👨‍💻</li>
                                        <li>Адаптивный дизайн (даже на холодильнике должно работать) ❄️</li>
                                        <li>Система категорий (потому что без категорий - это хаос) 🗂️</li>
                                    </ul>
                                </RoadmapItem>

                                <RoadmapItem status="planned" title="В разработке">
                                    <ul>
                                        <li>Система подписки (будем присылать уведомления, но не спамить - обещаем!) 📨
                                        </li>
                                        <li>Интеграция с Telegram (потому что куда же без него в 2023) 📱</li>
                                        <li>Email-рассылка новостей (только для тех, кто не боится нашего чувства юмора)
                                            😜
                                        </li>
                                        <li>Возможность самостоятельной публикации (когда-нибудь, может быть) 🎪</li>
                                        <li>Поиск по ключевым фразам (если сможем договориться с алгоритмом) 🔍</li>
                                    </ul>
                                </RoadmapItem>

                                <RoadmapItem status="future" title="В планах">
                                    <ul>
                                        <li>Поддержка видео-вставок (когда научимся снимать что-то кроме котиков) 🎥</li>
                                        <li>Рейтинги авторов и статей (будем хвалить друг друга) ⭐</li>
                                        <li>Система комментариев (где можно будет спорить о табах vs пробелах) 💬</li>
                                        <li>Статистика посещений (чтобы знать, что хотя бы мама заходит) 📈</li>
                                        <li>Персональные рекомендации (мы будем знать, что вам нравится... возможно,
                                            даже лучше вас) 🎯
                                        </li>
                                    </ul>
                                </RoadmapItem>
                            </div>
                        </section>

                        <section className={styles.section}>
                            <h2 className={styles.sectionTitle}>Присоединяйтесь! 🎉</h2>
                            <p className={styles.sectionText}>
                                Блог открыт для новых авторов, идей и сотрудничества. Если вам есть чем поделиться
                                с миром, или вы хотите участвовать в развитии проекта — напишите. Вместе мы сможем
                                создать что-то по-настоящему ценное (или хотя бы веселое).
                            </p>
                            <p className={styles.sectionText}>
                                P.S. Кофе и печеньки приветствуются! 🍪
                            </p>
                            <div className={styles.ctaButtons}>
                                <a href="/contact" className={styles.ctaButton}>Стать автором</a>
                                <a href="/contact" className={styles.ctaButtonSecondary}>Предложить идею</a>
                                <a href="/contact" className={styles.ctaButtonTertiary}>Отправить кофе</a>
                            </div>
                        </section>
                    </div>

                    <div className={styles.sidebar}>
                        <div className={styles.authorWidget}>
                            <h3 className={styles.widgetTitle}>Наша команда 👨‍💻👩‍💻</h3>
                            <div className={styles.authorsList}>
                                <div className={styles.author}>
                                    <div className={styles.authorAvatar}>V</div>
                                    <div className={styles.authorInfo}>
                                        <h4 className={styles.authorName}>Vivera</h4>
                                        <p className={styles.authorBio}>Основатель, разработчик, дизайнер, тестировщик,
                                            уборщик... в общем, всё делаю сам 😅</p>
                                        <div className={styles.authorStats}>
                                            <span>15+ статей</span>
                                            <span>∞ багов</span>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.author}>
                                    <div className={styles.authorAvatar}>?</div>
                                    <div className={styles.authorInfo}>
                                        <h4 className={styles.authorName}>Присоединяйтесь!</h4>
                                        <p className={styles.authorBio}>Место для нового автора (кофе и печеньки
                                            предоставляются) 🍪</p>
                                        <div className={styles.authorStats}>
                                            <span>0 статей</span>
                                            <span>много потенциала</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.statsWidget}>
                            <h3 className={styles.widgetTitle}>Статистика 📊</h3>
                            <div className={styles.statsGrid}>
                                <StatWidget number="15+" label="Статей" emoji="📝"/>
                                <StatWidget number="1" label="Автор" emoji="👨‍💻"/>
                                <StatWidget number="5" label="Категорий" emoji="🗂️"/>
                                <StatWidget number="∞" label="Идей" emoji="💡"/>
                                <StatWidget number="42" label="Чашки кофе" emoji="☕"/>
                                <StatWidget number="7" label="Исправленных багов" emoji="🐛"/>
                            </div>
                        </div>

                        <div className={styles.funFact}>
                            <h3 className={styles.widgetTitle}>Знаете ли вы? 🤓</h3>
                            <p>Этот раздел был написан после 3 чашек кофе и 2 часов борьбы с TypeScript. Кстати,
                                TypeScript победил.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPage;